import { Injectable } from '@angular/core';
import {
  DateUtils,
  HttpUtils,
  PageableResponse,
  PageableService,
} from '@pwc-bei/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HelpDeskResource } from '../models/api/helpDesk-resource';
import { HelpDesk } from '../models/helpDesk';

@Injectable({
  providedIn: 'root',
})
export class HelpDeskService extends PageableService<
HelpDeskResource,
HelpDesk
> {
  protected baseUrl: string = environment.apiUrl;
  protected endpoint: string = 'tls-fa-bandi/support-request';
  protected endpointEmail: string = 'tls-fa-bandi/support-request/email';

  sendHelpRequest(helpRequest: HelpDeskResource) {
    const url = `${environment.apiUrl}/${this.endpointEmail}`;

    return this.http.post<boolean>(url, helpRequest);
  }

  searchByEmail(search: Partial<HelpDeskResource>): Observable<HelpDesk[]> {
    const params = HttpUtils.toHttpParams(search);

    return this.get<PageableResponse<HelpDeskResource[]>>('b2c', {
      params,
    }).pipe(
      map((response: PageableResponse<HelpDeskResource[]>) =>
        this.extractPaginationInfo(response),
      ),
      map((list: HelpDeskResource[]): HelpDesk[] =>
        this.convertListToModel(list),
      ),
    );
  }

  convertResourceToModel(resource: HelpDeskResource): HelpDesk {
    const model: HelpDesk = {
      ...resource,
      creationDate: resource.creationDate
        ? DateUtils.dateToLocalDate(new Date(resource.creationDate))
        : null,
    };

    return model;
  }
  convertModelToResource(model: HelpDesk): HelpDeskResource {
    const resource: HelpDeskResource = {
      ...model,
      creationDate: model.creationDate
        ? DateUtils.localDateToDate(model.creationDate)
        : null,
    };

    return resource;
  }
}
